module.exports = __webpack_public_path__ + "static/media/img_1.2b4a0240.png";